<template>
  <GbwapsLayout title="GB WhatsApp Blog" :intro="pageIntro" :breadcrumb="breadcrumb">
    <div class="blog-page">
      <section class="blog-latest page-section">
        <h2>Latest articles</h2>
        <p class="blog-section-desc">
          Guides and explainers about GB WhatsApp download, safety, fixes, and how it compares to official WhatsApp.
        </p>
        <div class="blog-grid">
          <ArticleCard v-for="post in posts" :key="post.slug" :post="post" />
        </div>
      </section>

      <section
        v-for="cat in categories"
        :id="'blog-cat-' + cat.id"
        :key="cat.id"
        class="blog-category-section page-section site-section"
      >
        <h2>{{ cat.title }}</h2>
        <p class="blog-section-desc">{{ cat.description }}</p>
        <div v-if="postsByCategory(cat.id).length" class="blog-grid blog-grid--compact">
          <ArticleCard v-for="post in postsByCategory(cat.id)" :key="post.slug" :post="post" />
        </div>
        <p v-else class="blog-empty-note">
          <span class="article-category article-category--muted">{{ categoryLabel(cat.id) }}</span>
          — More guides coming soon. Browse latest articles above.
        </p>
      </section>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import ArticleCard from '@/components/gbwaps/ArticleCard.vue';
import { BLOG_CATEGORIES, BLOG_POSTS, getPostsByCategory } from '@/data/blog-content';

const CATEGORY_LABELS = {
	updates: 'Updates',
	tips: 'Tips',
	howto: 'How-To',
	security: 'Security',
	features: 'Features',
	troubleshooting: 'Troubleshooting',
	beginner: 'Beginner',
};

export default {
  name: 'BlogPage',
  components: { GbwapsLayout, ArticleCard },
  data() {
    return {
      pageIntro:
        'Latest news, tips, guides, and updates about GB WhatsApp APK, features, bans, and troubleshooting.',
      breadcrumb: [{ name: 'Home', to: '/' }, { name: 'Blog' }],
      categories: BLOG_CATEGORIES,
      posts: BLOG_POSTS,
    };
  },
  methods: {
    postsByCategory(categoryId) {
      return getPostsByCategory(categoryId);
    },
    categoryLabel(id) {
      return CATEGORY_LABELS[id] || id;
    },
  },
};
</script>
